import { AgentAvailability } from 'models/agent_status';

export default class StayAway {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (this.store.get().getAvailability() !== AgentAvailability.AWAY) {
      return;
    }

    this.store.resetPending();
  }

  get store() {
    return this.context.stores.agentStatus;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/agent_status/stay_away.js